/*
  CB 16/10/2026 - Pulsante punti fedelta' Smile.io su MOBILE (fino a 768px).
  - Sul pulsante compare una piccola "x": toccandola il pulsante svanisce e sul bordo
    SINISTRO dello schermo entra una linguetta azzurra con la margherita.
  - Toccando la linguetta il pulsante torna.
  - Mentre e' ridotto si nasconde anche il riquadro promozionale di Smile.
  - La scelta resta per tutta la visita (sessionStorage).
  - Con il carrello laterale aperto (o un pannello che blocca la pagina) pulsante,
    "x" e linguetta svaniscono con una dissolvenza (CSS).
  Smile ha due versioni del pulsante: "lite" prima del primo tocco
  (#smile-ui-lite-launcher-frame-container) e completa dopo
  (#smile-ui-container .smile-launcher-frame-container, classe smile-launcher-open
  quando il pannello punti e' aperto). La "x" segue quello visibile.
  Su desktop non cambia nulla. Stile in assets/cb-fixes-1510d.css (blocco 17).
*/
(function () {
  var KEY = 'cbSmileMin'
  var LAUNCHER = '#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container'
  var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null
  var root = document.documentElement
  var x = null
  var tab = null
  var min = false
  try { min = sessionStorage.getItem(KEY) === '1' } catch (e) {}

  var X_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  var DAISY = '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<g fill="#fff">' +
    '<ellipse cx="12" cy="5" rx="2.3" ry="4"/><ellipse cx="12" cy="19" rx="2.3" ry="4"/>' +
    '<ellipse cx="5" cy="12" rx="4" ry="2.3"/><ellipse cx="19" cy="12" rx="4" ry="2.3"/>' +
    '<ellipse cx="7" cy="7" rx="2.2" ry="3.8" transform="rotate(-45 7 7)"/><ellipse cx="17" cy="17" rx="2.2" ry="3.8" transform="rotate(-45 17 17)"/>' +
    '<ellipse cx="17" cy="7" rx="2.2" ry="3.8" transform="rotate(45 17 7)"/><ellipse cx="7" cy="17" rx="2.2" ry="3.8" transform="rotate(45 7 17)"/>' +
    '</g><circle cx="12" cy="12" r="3.4" fill="#f6c915"/></svg>'

  function isMobile() { return !!(mq && mq.matches) }

  function launcher() {
    var list = document.querySelectorAll(LAUNCHER)
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect()
      if (r.width > 0 && r.height > 0) return list[i]
    }
    return null
  }

  function ensureNodes() {
    if (!document.body) return
    if (!x) {
      x = document.createElement('button')
      x.type = 'button'
      x.className = 'cb-smile-x'
      x.setAttribute('aria-label', 'Nascondi il pulsante dei punti')
      x.hidden = true
      x.innerHTML = X_ICON
    }
    if (!tab) {
      tab = document.createElement('button')
      tab.type = 'button'
      tab.className = 'cb-smile-tab'
      tab.setAttribute('aria-label', 'Mostra il pulsante dei punti fedelta\u0300')
      tab.innerHTML = DAISY
    }
    // in fondo al body, dopo i contenitori Smile, per stare sopra al pulsante
    if (document.body.lastElementChild !== tab) {
      document.body.appendChild(x)
      document.body.appendChild(tab)
    }
  }

  function update() {
    ensureNodes()
    if (!x) return
    root.classList.toggle('cb-smile-min', min && isMobile())
    var l = launcher()
    if (l) {
      var r = l.getBoundingClientRect()
      // linguetta alla stessa altezza del pulsante
      var bottom = Math.max(12, Math.round(window.innerHeight - r.bottom - (48 - r.height) / 2))
      root.style.setProperty('--cb-smile-bottom', bottom + 'px')
    }
    var show = isMobile() && !min && !!l && !l.classList.contains('smile-launcher-open')
    if (show) {
      var rr = l.getBoundingClientRect()
      x.style.left = Math.round(rr.right - 14) + 'px'
      x.style.top = Math.round(rr.top - 12) + 'px'
    }
    if (x.hidden === show) x.hidden = !show
  }

  function setMin(v) {
    min = v
    try { sessionStorage.setItem(KEY, v ? '1' : '0') } catch (e) {}
    update()
  }

  document.addEventListener('click', function (e) {
    var t = e.target
    if (!t || !t.closest) return
    if (t.closest('.cb-smile-x')) { e.preventDefault(); setMin(true); return }
    if (t.closest('.cb-smile-tab')) { e.preventDefault(); setMin(false) }
  })

  var pending = false
  function schedule() {
    if (pending) return
    pending = true
    requestAnimationFrame(function () { pending = false; update() })
  }

  function start() {
    update()
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target
        if (t === x || t === tab) continue
        schedule()
        return
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] })
    window.addEventListener('resize', schedule)
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', schedule)
      else if (mq.addListener) mq.addListener(schedule)
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()